/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingTax from './accounting-tax';
import AccountingTaxDetail from './accounting-tax-detail';
import AccountingTaxUpdate from './accounting-tax-update';
import AccountingTaxDeleteDialog from './accounting-tax-delete-dialog';

const AccountingTaxRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingTax />} />
    <Route path="new" element={<AccountingTaxUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingTaxDetail />} />
      <Route path="edit" element={<AccountingTaxUpdate />} />
      <Route path="delete" element={<AccountingTaxDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingTaxRoutes;
